import { cn } from "@/lib/utils";

/**
 * PickerField - A label + picker + error wrapper for any picker component
 * @param {Object} props
 * @param {string} props.label - Field label
 * @param {string} props.error - Error message
 * @param {string} props.className - Additional classes for the wrapper
 * @param {React.ReactNode} props.children - The picker component
 */
export const PickerField = ({ label, error, className, children }) => {
  return (
    <div className={cn("space-y-1", className)}>
      {label && (
        <label className="text-xs font-medium text-muted-foreground tracking-wide">
          {label}
        </label>
      )}
      {children}
      {error && <p className="text-xs text-destructive">{error}</p>}
    </div>
  );
};
